<script>
  import { ignore } from '../../../Common/tools';
  import { External, M } from '../../../external';
  import { onDestroy, onMount } from 'svelte';
  import Checkbox from '../../../Common/Checkbox.svelte';
  import { LmsUtils } from '../../../LMS/utils/LmsUtils';
  import Loader from '../../../Common/Loader.svelte';

  export let valid = false, data = {}, onChange = ignore, enroll = true;

  let loaded = false;
  let settings = {};
  let circles = [];
  let groups = [];
  let activeCircle;

  let fillCircleGroups = async () => {
    if (!settings.circleId) {
      return;
    }

    let circle = circles.find(circle => circle.id === settings.circleId);
    activeCircle = await LmsUtils.getCircleDetailsByUrl(circle.url);

    if (activeCircle?.groups?.length) {
      groups = activeCircle.groups;
    } else {
      groups = [];
    }
  };

  let triggerChange = () => {
    data.name = circles.find(circle => circle.id === settings.circleId)?.name;
    if (data.name && settings.inGroup && settings.groupId && activeCircle?.groups?.length) {
      let groupName = activeCircle.groups.find(group => group.pageGroup.id === settings.groupId)?.pageGroup?.name;
      if (groupName) {
        data.name += ' > ' + groupName;
      }
    }
    data.settings = [{
      key: '0',
      value: JSON.stringify(settings)
    }];
    valid = true;
    onChange();
  };

  let onCircleSelected = async () => {
    await fillCircleGroups();
    settings.inGroup = false;
    settings.groupId = '';
    triggerChange();
  };

  let onCircleGroupSelected = () => {
    triggerChange();
  };

  onMount(async () => {
    if (!data) {
      data = {};
    }
    if (!data.settings) {
      data.settings = [];
    }

    const initialSettings = {
      circleId: '',
      groupId: '',
      inGroup: false
    };

    if (data.settings.length && data.settings[0].value) {
      settings = JSON.parse(data.settings[0].value) || initialSettings;
    } else {
      settings = initialSettings;
    }

    circles = await LmsUtils.listCircles();
    await fillCircleGroups();
    loaded = true;
  });

  onDestroy(() => {
    settings = null;
  });

</script>

<div class="col20 f-left small-rules mb-25">
  <h4 class="col20 f-left mt-15 mb-10 t-center" style="line-height:1.4;">{enroll ? M.ACTION_ENROLL_TO_CIRCLE : M.ACTION_UNENROLL_FROM_CIRCLE}</h4>
  {#if !loaded}
    <Loader compact={true} />
  {:else}
    <div class='popup-input-wrapper f-left mb-5'>
      <div class='info'>
        <h5>{M.CIRCLE}</h5>
      </div>
      <select class='page-select' bind:value={settings.circleId} on:change={onCircleSelected}>
        <option disabled value="">{M.SELECT_CIRCLE}</option>
        {#each circles as circle}
          <option value={circle.id}>{circle.name} ({circle.published ? M.PUBLISHED : M.NOT_PUBLISHED})</option>
        {/each}
      </select>
    </div>

    {#if groups.length}
      <div class='popup-input-wrapper mb-5 f-left' id='selectVisitedPage'>
        <Checkbox clz="f-left col20" bind:data={settings.inGroup} label='{enroll ? M.ENROLL_TO_GROUP_TITLE : M.UNENROLL_FROM_GROUP_TITLE}' />
        {#if settings.inGroup}
          <div class='info mt-15'>
            <h5>{M.CIRCLE_GROUP}</h5>
          </div>
          <select class='page-select' bind:value={settings.groupId} on:change={onCircleGroupSelected}>
            {#if !settings.groupId}
              <option disabled value="">{M.SELECT_CIRCLE_GROUP}</option>
            {/if}
            {#each groups as group}
              <option value={group.pageGroup.id}>{group.pageGroup.name}</option>
            {/each}
          </select>
        {/if}
      </div>
    {/if}
  {/if}
</div>
